// extracted by mini-css-extract-plugin
export var searchHeader = "_2t-0";
export var searchHeaderDark = "_2t-1";